import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Copy, ArrowRightLeft } from 'lucide-react';
import { toast } from 'sonner';

const Base64Tool = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [mode, setMode] = useState('encode');

  const encode = () => {
    try {
      const encoded = btoa(unescape(encodeURIComponent(input)));
      setOutput(encoded);
      toast.success('Encoded successfully!');
    } catch (e) {
      toast.error('Failed to encode');
    }
  };

  const decode = () => {
    try {
      const decoded = decodeURIComponent(escape(atob(input)));
      setOutput(decoded);
      toast.success('Decoded successfully!');
    } catch (e) {
      toast.error('Invalid Base64 string');
    }
  };

  const copyOutput = () => {
    if (output) {
      navigator.clipboard.writeText(output);
      toast.success('Copied!');
    }
  };

  const swap = () => {
    setInput(output);
    setOutput('');
  };

  return (
    <div className="space-y-4" data-testid="base64-tool">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">Base64 Encoder/Decoder</h3>
      </div>

      <Tabs value={mode} onValueChange={setMode}>
        <TabsList className="w-full">
          <TabsTrigger value="encode" className="flex-1">Encode</TabsTrigger>
          <TabsTrigger value="decode" className="flex-1">Decode</TabsTrigger>
        </TabsList>
      </Tabs>

      <Textarea
        placeholder={mode === 'encode' ? 'Enter text to encode...' : 'Enter Base64 to decode...'}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        className="min-h-[120px] bg-background/50 font-mono text-sm"
        data-testid="input"
      />

      <div className="flex gap-2">
        <Button onClick={mode === 'encode' ? encode : decode} className="flex-1" data-testid="convert-btn">
          {mode === 'encode' ? 'Encode' : 'Decode'}
        </Button>
        <Button variant="outline" onClick={swap} data-testid="swap-btn">
          <ArrowRightLeft className="w-4 h-4" />
        </Button>
      </div>

      {output && (
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Output</span>
            <Button variant="ghost" size="sm" onClick={copyOutput}>
              <Copy className="w-4 h-4 mr-1" /> Copy
            </Button>
          </div>
          <Textarea
            value={output}
            readOnly
            className="min-h-[120px] bg-background/50 font-mono text-sm"
            data-testid="output"
          />
        </div>
      )}
    </div>
  );
};

export default Base64Tool;
